// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__sJhyb","move":"styles_move__OIvjR","success":"styles_success__3XWVL","error":"styles_error__3oESz"};